var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0406 0H17.9586C8.04304 0 0.00488281 8.04052 0.00488281 17.959V18.041C0.00488281 27.9595 8.04304 36 17.9586 36H18.0406C27.9561 36 35.9943 27.9595 35.9943 18.041V17.959C35.9943 8.04052 27.9561 0 18.0406 0Z",
    fill: "url(#paint0_linear_64_16391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5681 7.32416H12.4319C9.35539 7.32416 6.85254 9.82775 6.85254 12.9052V23.0962C6.85254 26.1736 9.35539 28.6772 12.4319 28.6772H23.5681C26.6446 28.6772 29.1475 26.1736 29.1475 23.0962V12.9052C29.1475 9.82775 26.6446 7.32416 23.5681 7.32416ZM8.82078 12.9052C8.82078 10.9137 10.441 9.29298 12.4319 9.29298H23.5681C25.559 9.29298 27.1792 10.9137 27.1792 12.9052V23.0962C27.1792 25.0877 25.559 26.7084 23.5681 26.7084H12.4319C10.441 26.7084 8.82078 25.0877 8.82078 23.0962V12.9052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 23.1903C20.8613 23.1903 23.1901 20.862 23.1901 17.9989C23.1901 15.1359 20.8626 12.8076 18.0003 12.8076C15.1381 12.8076 12.8105 15.1359 12.8105 17.9989C12.8105 20.862 15.1381 23.1903 18.0003 23.1903ZM18.0003 14.7777C19.7769 14.7777 21.2219 16.2231 21.2219 18.0002C21.2219 19.7773 19.7769 21.2227 18.0003 21.2227C16.2238 21.2227 14.7788 19.7773 14.7788 18.0002C14.7788 16.2231 16.2238 14.7777 18.0003 14.7777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6708 13.6465C24.4412 13.6465 25.0691 13.0197 25.0691 12.2478C25.0691 11.4759 24.4424 10.8491 23.6708 10.8491C22.8991 10.8491 22.2725 11.4759 22.2725 12.2478C22.2725 13.0197 22.8991 13.6465 23.6708 13.6465Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_16391",
    x1: 5.26277,
    y1: 30.7406,
    x2: 30.7439,
    y2: 5.2682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3941273f6baf86f69f16bf563ba8c378.svg";
export { ForwardRef as ReactComponent };